import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import * as v from "valibot";
import { AuthShell } from "@/shared/ui/auth-shell";
import { safeRedirectPath } from "@/shared/lib/auth";

const searchParams = v.object({
  redirect: v.optional(v.string()),
  // QA and dev sites: the login-code key (pages/login/lib/login-code-key.ts). Listed so the router keeps it
  // in the address until the login form has read it.
  "login-code-key": v.optional(v.string()),
});

const AuthLayoutComponent = () => (
  <AuthShell>
    <Outlet />
  </AuthShell>
);

export const Route = createFileRoute("/auth")({
  component: AuthLayoutComponent,
  validateSearch: searchParams,
  beforeLoad: ({ context, search }) => {
    if (context.me) throw redirect({ to: safeRedirectPath(search.redirect) });
  },
});
